import { Heart, Phone, Mail, MapPin } from 'lucide-react';
import Logo from '../Logo.png';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img src="/gallery/logo.png" alt="Kinder Heaven" className="w-12 h-12 object-contain" />
              <span className="text-xl font-bold font-display text-purple-primary">Kinder Heaven</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Little Learners - Endless Possibilities. Comprehensive after-school learning for Nursery to Grade 5 with personalized academics and skill development.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 font-display">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#home" className="hover:text-purple-primary transition-colors">Home</a></li>
              <li><a href="#about" className="hover:text-purple-primary transition-colors">About Us</a></li>
              <li><a href="#programs" className="hover:text-purple-primary transition-colors">Programs</a></li>
              <li><a href="#admissions" className="hover:text-purple-primary transition-colors">Admissions</a></li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="text-lg font-bold mb-4 font-display">Policies</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#privacy" className="hover:text-purple-primary transition-colors">Privacy Policy</a></li>
              <li><a href="#terms" className="hover:text-purple-primary transition-colors">Terms of Service</a></li>
              <li><a href="#fees" className="hover:text-purple-primary transition-colors">Fee Structure</a></li>
              <li><a href="#faq" className="hover:text-purple-primary transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 font-display">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-gray-400">
                <Phone size={16} className="flex-shrink-0 mt-0.5" />
                <span>+91-9267633372</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Phone size={16} className="flex-shrink-0 mt-0.5" />
                <span>+91-8272876283</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Mail size={16} className="flex-shrink-0 mt-0.5" />
                <a href="mailto:kinderheavenstudio@gmail.com" className="hover:text-purple-primary transition-colors">kinderheavenstudio@gmail.com</a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin size={16} className="flex-shrink-0 mt-0.5" />
                <span>Nal Road, Amroha</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8 sm:my-12"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
          {/* Copyright */}
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} Kinder Heaven. All rights reserved.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <a href="https://www.facebook.com/share/18iQVhLUpa/" target="_blank" rel="noopener noreferrer" title="Facebook" className="text-gray-400 hover:text-purple-primary transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M22 12.07C22 6.49 17.52 2 12 2S2 6.49 2 12.07C2 17.08 5.66 21.06 10.44 21.9v-6.38h-3.15v-2.45h3.15V9.41c0-3.12 1.86-4.84 4.7-4.84 1.36 0 2.78.24 2.78.24v3.05h-1.56c-1.54 0-2.02.96-2.02 1.95v2.34h3.43l-.55 2.45h-2.88V21.9C18.34 21.06 22 17.08 22 12.07z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/kinder_heaven?igsh=NmQybWd0aHNncmpz" target="_blank" rel="noopener noreferrer" title="Instagram" className="text-gray-400 hover:text-purple-primary transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M7 2C4.24 2 2 4.24 2 7v10c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5H7zm8.5 4.5a1 1 0 110 2 1 1 0 010-2zM12 7.5A4.5 4.5 0 1012 16.5 4.5 4.5 0 0012 7.5zm0 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5z" />
              </svg>
            </a>
            <a href="https://youtube.com/@kinderheaven-w8m?si=wqZJaCaSlrQjQhNm" target="_blank" rel="noopener noreferrer" title="YouTube" className="text-gray-400 hover:text-purple-primary transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M23.5 6.2a2.8 2.8 0 0 0-1.97-1.98C19.73 3.5 12 3.5 12 3.5s-7.73 0-9.53.7A2.8 2.8 0 0 0 .5 6.2 29.67 29.67 0 0 0 0 12a29.67 29.67 0 0 0 .5 5.8 2.8 2.8 0 0 0 1.97 1.98c1.8.7 9.53.7 9.53.7s7.73 0 9.53-.7a2.8 2.8 0 0 0 1.97-1.98A29.67 29.67 0 0 0 24 12a29.67 29.67 0 0 0-.5-5.8zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" />
              </svg>
            </a>
            <a href="mailto:kinderheavenstudio@gmail.com" title="Email" className="text-gray-400 hover:text-purple-primary transition-colors">
              <Mail size={20} />
            </a>
          </div>
        </div>

        {/* Brand Note */}
        <div className="text-center mt-6 sm:mt-8 text-xs text-gray-500">
          <p>Designed with <Heart size={12} className="inline" /> for the future of education</p>
        </div>
      </div>
    </footer>
  );
}
